/* The Plate Room — custom behaviour (assets/plateroom.js). Loaded deferred from layout/theme.liquid. */
(function () {
  'use strict';
  var html = document.documentElement;
  html.classList.add('pr-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- 1. Scroll reveal with per-row stagger ---- */
  function setupReveal() {
    if (reduce || !('IntersectionObserver' in window)) return;
    var targets = [];
    // product cards, collection cards, section headers, pillars — never the hero (it has its own entrance)
    document.querySelectorAll('product-card, .product-card, .resource-list__item, .pr-pillar').forEach(function (el) {
      if (el.closest('.hero')) return;
      targets.push(el);
    });
    document.querySelectorAll('.shopify-section [class*="__ttl"], .shopify-section [class*="__sub"]').forEach(function (el) {
      if (el.closest('.hero')) return;
      targets.push(el);
    });
    // stagger index = position among siblings that are also targets
    targets.forEach(function (el) {
      var i = 0, s = el;
      while ((s = s.previousElementSibling)) { if (targets.indexOf(s) !== -1) i++; }
      el.style.setProperty('--pr-i', String(i % 8));
      el.classList.add('pr-reveal');
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    targets.forEach(function (el) { io.observe(el); });
    // Safety net: whatever is on screen gets shown even if IntersectionObserver is throttled
    function sweep() {
      var h = window.innerHeight * 1.05;
      for (var k = 0; k < targets.length; k++) {
        var el = targets[k];
        if (el.classList.contains('is-in')) continue;
        if (el.getBoundingClientRect().top < h) el.classList.add('is-in');
      }
    }
    requestAnimationFrame(sweep);
    setTimeout(sweep, 800);
    setTimeout(sweep, 2500);
    window.addEventListener('load', sweep);
    var sweeping = false;
    window.addEventListener('scroll', function () {
      if (sweeping) return;
      sweeping = true;
      setTimeout(function () { sweeping = false; sweep(); }, 120);
    }, { passive: true });
  }

  /* ---- 2. Number the "Why" pillars (01 · 02 · 03) ---- */
  function setupPillars() {
    var why = document.querySelector('.shopify-section[id$="section_x8mrnx"]');
    if (!why) return;
    // pillars = group blocks that contain an h3/h4 and a paragraph, excluding the section header group
    var groups = Array.prototype.filter.call(why.querySelectorAll('.group-block'), function (g) {
      return g.querySelector('h3, h4') && g.querySelector('p') && !g.querySelector('h2') && !g.querySelector('.group-block');
    });
    groups.forEach(function (g, i) {
      g.classList.add('pr-pillar');
      g.setAttribute('data-pr-n', (i + 1 < 10 ? '0' : '') + (i + 1));
    });
  }

  /* ---- 3. Header shadow after scroll + back-to-top ---- */
  function setupScrollUI() {
    var top = document.createElement('button');
    top.className = 'pr-top';
    top.type = 'button';
    top.setAttribute('aria-label', 'Back to top');
    top.innerHTML = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8 13V3M3.5 7.5 8 3l4.5 4.5"/></svg>';
    top.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
    document.body.appendChild(top);

    var hero = document.querySelector('.hero__media img');
    var parallaxOn = !reduce && hero && window.matchMedia('(min-width: 990px)').matches;
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY || window.pageYOffset;
        html.classList.toggle('pr-scrolled', y > 8);
        top.classList.toggle('is-on', y > 900);
        if (parallaxOn && y < 1400) hero.style.setProperty('--pr-parallax', (y * 0.12).toFixed(1) + 'px');
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- 4. Re-run reveal for content the theme injects later (filters, load more, section rerender) ---- */
  function watchMutations() {
    if (reduce || !('MutationObserver' in window)) return;
    var pending = false;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () {
        pending = false;
        document.querySelectorAll('product-card:not(.pr-reveal), .product-card:not(.pr-reveal)').forEach(function (el) {
          el.classList.add('pr-reveal');
          requestAnimationFrame(function () { el.classList.add('is-in'); });
        });
      }, 120);
    });
    var main = document.getElementById('MainContent') || document.body;
    mo.observe(main, { childList: true, subtree: true });
  }

  function init() {
    setupPillars();
    setupReveal();
    setupScrollUI();
    watchMutations();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Shopify theme editor: re-apply after a section re-renders
  document.addEventListener('shopify:section:load', function () { setupPillars(); setupReveal(); });
})();
